import { createController, prepActions } from "~/hocs/crud";
import { service } from "./service";
import equationTextSaga from "./sagas";

const actions = prepActions(service);
const equationListSagas = createController(service, actions);

export { equationListSagas, actions, equationTextSaga };
